/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  clearSelectedCategory,
  reset,
  resetMarketplaceSearch,
  setMarketplaceCategories,
  setMarketplaceSafetyItems,
  setMarketplaceSearchResults,
  setSelectedCategory,
  setSelectedListing,
  updateMarketplaceListings,
} from './actions';
import {
  MarketplaceCategory,
  MarketplaceListingItem,
  MarketplaceListings,
  MarketplaceSafetyItem,
} from './models';

export interface MarketplaceState {
  categories: MarketplaceCategory[];
  selectedCategory: string | undefined;
  selectedListing: string | undefined;
  searchResults: MarketplaceListings;
  listings: { [key: string]: MarketplaceListingItem };
  suggestedSafetyItems: MarketplaceSafetyItem[];
}

const initialState: MarketplaceState = {
  searchResults: [],
  listings: {},
  selectedListing: undefined,
  selectedCategory: undefined,
  categories: [],
  suggestedSafetyItems: [],
};

// eslint-disable-next-line import/prefer-default-export, @typescript-eslint/no-empty-function
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(setSelectedCategory, (state, action) => {
    state.selectedCategory = action.payload;
  });

  builder.addCase(clearSelectedCategory, (state) => {
    state.selectedCategory = initialState.selectedCategory;
  });

  builder.addCase(setMarketplaceCategories, (state, action) => {
    state.categories = action.payload;
  });

  builder.addCase(setMarketplaceSearchResults, (state, action) => {
    // Steal the search results and store them in the listings slice as well. The search results slice
    // is short-lived, but we can still use the data elsewhere
    state.listings = {
      ...action.payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, state.listings),
    };
    state.searchResults = action.payload;
  });

  builder.addCase(updateMarketplaceListings, (state, action) => {
    state.listings = {
      ...action.payload.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, state.listings),
    };
  });

  builder.addCase(setSelectedListing, (state, action) => {
    state.selectedListing = action.payload;
  });

  builder.addCase(resetMarketplaceSearch, (state) => {
    state.searchResults = initialState.searchResults;
  });

  builder.addCase(reset, (state) => {
    const { categories } = state;
    Object.assign(state, initialState, { categories });
  });

  builder.addCase(setMarketplaceSafetyItems, (state, action) => {
    state.suggestedSafetyItems = action.payload;
  });
});
